export default __webpack_public_path__ + "static/media/EZLOCAL.c3e56fb3.png";